import React from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { brand } from "../theme";

// Mensaje para listas vacías, con ícono y acción opcional
const EmptyState = ({ icon, title, text, action }) => (
  <Box
    sx={{
      textAlign: "center",
      py: { xs: 6, md: 8 },
      px: 3,
      border: 1,
      borderStyle: "dashed",
      borderColor: "divider",
      borderRadius: 4,
      bgcolor: "background.paper",
    }}
  >
    {icon && (
      <Box
        sx={{
          width: 56,
          height: 56,
          mx: "auto",
          mb: 2,
          borderRadius: "50%",
          display: "grid",
          placeItems: "center",
          bgcolor: alpha(brand.coral, 0.12),
          color: "secondary.dark",
          "& svg": { fontSize: 28 },
        }}
      >
        {icon}
      </Box>
    )}
    <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
      {title}
    </Typography>
    {text && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {text}
      </Typography>
    )}
    {action && <Box sx={{ mt: 2.5 }}>{action}</Box>}
  </Box>
);

export default EmptyState;
